<template>
  <div>
    <InfoDetail v-if="pageStatus === 'infoDetail'" @changeToCompanyVerify="changeToCompanyVerify()" @changeToCertVerify="changeToCertVerify()"></InfoDetail>
    <CompanyVerify v-if="pageStatus === 'companyVerify'" @changeToInfoDetail="changeToInfoDetail()"></CompanyVerify>
    <CertVerify v-if="pageStatus === 'certVerify'" @changeToInfoDetail="changeToInfoDetail()"></CertVerify>
  </div>
</template>
<script>
import InfoDetail from "./infoDetail/InfoDetail";
import CompanyVerify from "./companyVerify/CompanyVerify";
import CertVerify from "../personInfo/certVerify/CertVerify";
export default {
  name: "VerifyCenter",
  components: {
    InfoDetail,
    CompanyVerify,
    CertVerify
  },
  data() {
    return {
      pageStatus: "infoDetail",
    };
  },
  methods: {
    changeToCompanyVerify() {
      this.pageStatus = "companyVerify";
    },
    changeToInfoDetail() {
      this.pageStatus = "infoDetail";
    },
    changeToCertVerify() {
      this.pageStatus = "certVerify";
    },
  },
};
</script>

<style>
</style>